var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsideAllow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_439_10959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 0C5.8875 0 6.33333 0.445833 6.33333 1V2.66667H12.3333V1C12.3333 0.445833 12.7792 0 13.3333 0C13.8875 0 14.3333 0.445833 14.3333 1V2.66667H16C17.4708 2.66667 18.6667 3.8625 18.6667 5.33333V6V8H18H16.6667H14.6667H2V18.6667C2 19.0333 2.3 19.3333 2.66667 19.3333H11.8542C12.3667 20.1167 13.0208 20.7958 13.7833 21.3333H2.66667C1.19583 21.3333 0 20.1375 0 18.6667V8V6V5.33333C0 3.8625 1.19583 2.66667 2.66667 2.66667H4.33333V1C4.33333 0.445833 4.77917 0 5.33333 0ZM12 15.3333C12 13.742 12.6321 12.2159 13.7574 11.0907C14.8826 9.96548 16.4087 9.33333 18 9.33333C19.5913 9.33333 21.1174 9.96548 22.2426 11.0907C23.3679 12.2159 24 13.742 24 15.3333C24 16.9246 23.3679 18.4508 22.2426 19.576C21.1174 20.7012 19.5913 21.3333 18 21.3333C16.4087 21.3333 14.8826 20.7012 13.7574 19.576C12.6321 18.4508 12 16.9246 12 15.3333ZM21.2375 18.6958C20.9792 17.9042 20.2375 17.3333 19.3583 17.3333H16.6417C15.7667 17.3333 15.0208 17.9042 14.7625 18.6958C15.6042 19.5042 16.7417 20 18 20C19.2583 20 20.3958 19.5042 21.2375 18.6958ZM20 14C20 13.4696 19.7893 12.9609 19.4142 12.5858C19.0391 12.2107 18.5304 12 18 12C17.4696 12 16.9609 12.2107 16.5858 12.5858C16.2107 12.9609 16 13.4696 16 14C16 14.5304 16.2107 15.0391 16.5858 15.4142C16.9609 15.7893 17.4696 16 18 16C18.5304 16 19.0391 15.7893 19.4142 15.4142C19.7893 15.0391 20 14.5304 20 14Z",
    fill: "#FFCB00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_439_10959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21.3333,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsideAllow);
export default __webpack_public_path__ + "static/media/aside_allow.b8d04644cccb88975e37c14774f48a93.svg";
export { ForwardRef as ReactComponent };